/**
 * ローディング画像の表示・非表示を切り替えます。
 *
 * @param {String} action `show` で表示、`hide` で非表示
 */
export function loadingImage(action) {
    const displayValue = action === 'show' ? 'block' : 'none';
    document.getElementById('mtapp-loading-image').style.display = displayValue;
}
